import { fork } from 'redux-saga/effects';
import { connectSaga } from '../modules/account/effects/connectSaga';
import { basicConfigSaga } from 'modules/common/effects/basicConfigSaga';

export function* rootSaga() {
  yield fork(connectSaga);
  yield fork(basicConfigSaga);
}
